module.exports = __webpack_public_path__ + "static/media/aww.7b8e2fdd.jpeg";